import { ArrowBigRight, FuelIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { PosData } from "../types/pos.type";
import { optionsValues } from "../constants/status.constant";
import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder";
import { formatDateTime } from "@/common/utils/formatters";
import Button from "../../../common/components/Button";

export class PosTransformer {
  static tableTransformer(operationKlassToCheckPermission?: string) {
    return (posArray: PosData[]) => {
      return posArray.map((pos) => {
        return {
          ...pos,
          status: optionsValues[pos?.status],
          reference_number: pos?.reference_number,
          establishment_company_branch_display_name: pos.establishment_company_branch?.general_information && (
            <div className="flex items-center gap-2">
              <ImageWithPlaceholder
                placeholderIcon={FuelIcon}
                className="w-6 h-6"
                iconClassName="w-4 h-4"
                url={pos.establishment_company_branch?.general_information?.company_logo?.url}
              />

              <p>
                {pos.establishment_company_branch?.general_information?.fantasy_name}
              </p>
            </div>
          ),
          last_consumption: pos?.last_consumption_protocol_number && pos?.last_consumption_created_at ? (`${pos?.last_consumption_protocol_number} - ${formatDateTime(new Date(pos.last_consumption_created_at))}`) : '--',
          model_display: pos?.model?.display_name,
          last_seen_at: pos.last_seen_at ? formatDateTime(new Date(pos.last_seen_at)) : '',
          actions: <Link to={`/pos/${pos.id}`}>
            <Button className="bg-transparent hover:bg-transparent p-0" operationKlassToCheckPermission={operationKlassToCheckPermission}>
              <ArrowBigRight />
            </Button>
          </Link>
        };
      });
    };
  }

  static optionsTransformer() {
    return (pos: PosData[]) => {
      return pos.map((posMachine) => {
        return {
          value: posMachine.id,
          label: `${posMachine.reference_number} (${posMachine.model.display_name})`,
        };
      });
    };
  }

  static quickSearchModelTransformer() {
    return (posArray: PosData[]) => {
      return posArray.map((pos) => ({
        route: `/pos/${pos.id}`,
        items: [
          ['Código', pos?.reference_number],
          ['Modelo', pos?.model?.display_name],
          ['Status', optionsValues[pos?.status]],
        ]
      }));
    };
  }
}
